"use client";

import React, { createRef } from "react";
import { ObjectService } from "namirasoft-core";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IValidationProps } from "../props/IValidationProps";
import { NSBoxBaseCombo, INSBoxBaseComboProps } from "../components/NSBoxBaseCombo";
import { INSBox } from "./INSBox";

interface NSBoxEnumProps<Data> extends IBaseComponentProps, IValidationProps, INSBoxBaseComboProps<NSBoxEnum<Data>>
{
	getEnumObject: () => { [s: string]: Data };
	input?: IBaseComponentProps;
}

export class NSBoxEnum<Data> extends React.Component<NSBoxEnumProps<Data>> implements INSBox
{
	public NSBoxBaseCombo = createRef<NSBoxBaseCombo<string>>();
	constructor(props: NSBoxEnumProps<Data>)
	{
		super(props);
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
		this.getValueOne = this.getValueOne.bind(this);
		this.setValueOne = this.setValueOne.bind(this);
		this.getValueAll = this.getValueAll.bind(this);
		this.setValueAll = this.setValueAll.bind(this);
		this.getValueEnumOne = this.getValueEnumOne.bind(this);
		this.getValueEnumAll = this.getValueEnumAll.bind(this);
		this.reload = this.reload.bind(this);
	}
	isEmpty(value: string)
	{
		if ((value ?? "").trim())
			return false;
		return true;
	}
	getError(): string | null
	{
		return this.NSBoxBaseCombo.current?.getError() ?? null;
	}
	getValue(checkError: boolean = true): string[] | string | null
	{
		return this.NSBoxBaseCombo.current?.getValue(checkError) ?? null;
	}
	setValue(value: string[] | string | null, callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setValue(value, callback);
	}
	getValueOne(checkError: boolean = true): string | null
	{
		return this.NSBoxBaseCombo.current?.getValueOne(checkError) ?? null;
	}
	setValueOne(value: string | null, callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setValueOne(value, callback);
	}
	getValueAll(): string[]
	{
		return this.NSBoxBaseCombo.current?.getValueAll() ?? [];
	}
	setValueAll(values: string[], callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setValueAll(values, callback);
	}
	getValueEnumOne(enumObject: { [s: string]: Data }, _default: Data, checkError: boolean = true): Data | null
	{
		return new ObjectService(this.getValueOne(checkError)).getEnum(enumObject, _default);
	}
	getValueEnumAll(enumObject: { [s: string]: Data }, _default: Data): Data[]
	{
		let values = this.getValueAll();
		return values.map(value => new ObjectService(value).getEnum(enumObject, _default));
	}
	reload()
	{
		this.NSBoxBaseCombo.current?.reload();
	}
	override render()
	{
		return <NSBoxBaseCombo<string>
			ref={this.NSBoxBaseCombo}
			{...this.props}
			onChanged={(_) =>
			{
				this.props.onChanged?.(this);
			}}
			onClicked={(_) =>
			{
				this.props.onClicked?.(this);
			}}
			getItems={async () =>
			{
				let obj = this.props.getEnumObject();
				let rows = Object.keys(obj);
				if (this.props.valids)
					rows = rows.filter(x => this.props.valids?.includes(x));
				if (this.props.invalids)
					rows = rows.filter(x => !this.props.invalids?.includes(x));
				return { count: rows.length, rows };
			}}
			getValue={x => x}
			getTitle={x => x}
			getSort={() => null}
		/>
	}
}